import { NavigationSubItem } from "../navigation-item"

export class IncentivesSubItem extends NavigationSubItem {
  readonly id = "incentives"
  readonly label = "Incentivize"
  readonly href = "/incentivize"
  readonly iconName = "incentive-icon"
  readonly isExternal = false
  readonly tabs = []
}

